import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IStockReorder, StockReorderService } from '@shared/services/stock-reorder.service';

@Component({
	selector: 'app-delete-stock-reorder',
	templateUrl: './delete-stock-reorder.component.html',
	styleUrl: './delete-stock-reorder.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteStockReorderComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public item: IStockReorder,
		public dialogRef: MatDialogRef<DeleteStockReorderComponent>,
		private service: StockReorderService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';
		this.service.deleteById(this.item.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
